var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-data-table", {
    staticClass: "pm-index",
    attrs: {
      loading: _setup.tableState.isLoading,
      headers: _setup.headers,
      items: _setup.tableState.items
    },
    scopedSlots: _vm._u([
      {
        key: "item.title",
        fn: function({ item }) {
          return [
            _c("div", { staticClass: "header-title" }, [
              _c("span", [_vm._v(_vm._s(item.title))]),
              _vm._v(" "),
              _c("span", {}, [_vm._v("(" + _vm._s(item.equipment) + ")")])
            ])
          ]
        }
      },
      {
        key: "item.action",
        fn: function({ item }) {
          return [
            _c(
              "div",
              [
                _c(
                  "v-icon",
                  {
                    attrs: { color: "yellow darken-3" },
                    on: { click: () => _setup.onEdit(item.id) }
                  },
                  [_vm._v("mdi-pencil")]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      text: "",
                      loading: _setup.printingTemplate.has(item.id)
                    },
                    on: {
                      click: function($event) {
                        return _setup.printTemplate(item.id)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { color: "red" } }, [
                      _vm._v("mdi-file")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }